import { Printer, QrCode } from 'lucide-react';
import type { DeskOrder } from '@/services/deskService';

interface OrderQRStatusProps {
  order: DeskOrder;
}

export function OrderQRStatus({ order }: OrderQRStatusProps) {
  if (order.memory?.print_count && order.memory.print_count > 0) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-white bg-green-600 uppercase tracking-wider px-2.5 py-1 rounded-sm">
        <Printer className="w-3 h-3" />
        Impreso {order.memory.print_count}x
      </span>
    );
  }
  if (order.memory) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-[#1e1e1e] bg-[#eeeeee] uppercase tracking-wider px-2.5 py-1 rounded-sm">
        <QrCode className="w-3 h-3" />
        QR generado
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 uppercase tracking-wider px-2.5 py-1 rounded-sm">
      <QrCode className="w-3 h-3" />
      Sin QR
    </span>
  );
}
